module.exports = __webpack_public_path__ + "img/order-plastic-cards.d6809aab.svg";